(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('TaxCodeSearch', TaxCodeSearch);

    TaxCodeSearch.$inject = ['$resource'];

    function TaxCodeSearch($resource) {
        var resourceUrl =  'api/_search/tax-codes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
